import { PermissionsPath } from '@yuno/dashboard-authentication-mfe'
import { useGetPermissions } from '@yuno/dashboard-api-mfe'
import { useEffect, useState } from 'react'

export const useVerifyPathPermission = () => {
  const {
    refetch: fetchRoles,
    status: statusFetch,
    data: dataPermissions,
  } = useGetPermissions()
  const [rol, setRol] = useState('')
  const [permissions, setPermissions] = useState<any>([])

  useEffect(() => {
    if (permissions.length > 0) {
      verifyPath(window.location.pathname)
    }
  }, [permissions])

  const verifyPath = (path: string) => {
    if (path === '/' || PermissionsPath?.[path] === 'all') return

    const cleanedPath = PermissionsPath?.[path]
      ? path
      : Object.keys(PermissionsPath).find((el) => path.includes(el))

    if (!permissions.includes(PermissionsPath?.[cleanedPath])) {
      window.singleSpaNavigate('/')
    }
  }

  useEffect(() => {
    if (statusFetch === 'success') {
      setPermissions(dataPermissions.map((item) => item.permission_name))
    }
  }, [statusFetch])

  useEffect(() => {
    if (rol) {
      fetchRoles()
    }
  }, [rol])

  return {
    verifyPath,
    statusFetch,
    fetchRoles,
    dataPermissions,
    rol,
    setRol,
    permissions,
  }
}
